import router, {
	resetRouter
} from '@/router'
import {
	getUserInfo,
	refreshToken
} from '@/common/api/login.js'
const state = {
	token: window.localStorage.getItem('access_token'),
	role: ''
}

const mutations = {
	SET_ROLES: (state, role) => {
		state.role = role
	}
}

const actions = {
	uploadToken({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			refreshToken().then(() => {
				
			})
		})
	},
	getInfo({
		commit,
		state
	}) {
		return new Promise((resolve, reject) => {
			getUserInfo().then(response => {
				const data = response
				if (data.code == 0) {
					commit('SET_ROLES', data.data.type)
					resolve(data.data)
				} else {
					reject(data)
				}
			}).catch(error => {
				reject(error)
			})
		})
	},
	logout({
		commit,
		state
	}) {
		window.localStorage.setItem('access_token', '')
		localStorage.setItem("refresh_token",'')
		window.localStorage.setItem('userinfo', '')
		window.sessionStorage.setItem("breadcrumb", '')
		commit('SET_ROLES', '')
		resetRouter()
	},
	// dynamically modify permissions
	async changeRoles({
		commit,
		dispatch
	}) {
		const {
			data
		} = await getUserInfo()
		console.log(data)
		let role = data.type
		commit('SET_ROLES', role)
		resetRouter()
		const accessRoutes = await dispatch('permission/generateRoutes', role, {
			root: true
		})
		router.addRoutes(accessRoutes)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}